import {api} from "../../system/api";

export default {
    fetchTemplateBags: (params) => api.get('bag-templates', {params}),
    createTemplateBag: (data) => api.post('bag-templates', data),
    updateTemplateBag: (id, data) => api.put(`bag-templates/${id}`, data),
    fetchTemplateBagDetail: (id, params) => api.get(`bag-templates/${id}`, {params}),
    updateBagLastmile: (id, data) => api.put(`lastmile-bags/${id}`, data),
}